import styled from 'styled-components'

import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const ImageBlockWithText = styled(GriddedContentBlock)`
  /* Naming Convenience */
  margin-top: 0;
`

export const AdditionalCtaStylesRightLayout = `
margin-top: 18px;
grid-column: 2 / 10;
padding: 15px 0;

@media ${DEVICE.tabletL} {
  padding: 0 32px 0 32px;
  grid-column:  1 / 5;
  margin-top: 20px;
  padding-bottom: 40px;
}
`

export const AdditionalCtaStylesLeftLayout = `
margin-top: 18px;
grid-column: 2 / 10;
padding: 15px 0;

@media ${DEVICE.tabletL} {
  padding: 0 32px 0 32px;
  grid-column:  3 / 8;
  margin-top: 20px;
  padding-bottom: 40px;
}
`

export const ImageBlockIrregularGrid = styled.div`
  grid-column: 2 / 12;
  display: grid;

  /* half width of circle accent, 8 rows, half width of circle accent */
  grid-template-columns: 27px repeat(8, 1fr) 27px;
  grid-template-rows: 27px 27px auto 22px auto;

  @media ${DEVICE.tabletL} {
    /* 10 columns, with some offset for an irregular col  */
    grid-template-columns: ${({ isImageRightLayout }) =>
      isImageRightLayout
        ? 'repeat(8, 1fr) 0.5fr 0.5fr'
        : '0.5fr 0.5fr repeat(8, 1fr)'};
    grid-template-rows: 1fr;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const TextContainer = styled.div`
  grid-column: 1 / 11;
  grid-row: 4 / 6;
  background-color: var(--content-background-light);
  border-radius: 5px;
  padding: 32px 27px 27px 0;
  display: grid;
  grid-template-columns: 27px repeat(8, 1fr) 27px;

  @media ${DEVICE.tabletL} {
    padding: unset;
    grid-column: ${({ isImageRightLayout }) =>
      isImageRightLayout ? '1 / 8' : '4 / 12'};
    grid-row: 1;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    margin-top: 70px;
  }

  @media ${DEVICE.laptopL} {
    margin-top: 116px;
  }
`

export const Title = styled.h2`
  font-weight: 300;
  font-size: 2.8rem;
  color: var(--highlight-blue);
  grid-column: 2 / 10;

  @media ${DEVICE.tabletL} {
    padding: 19px 32px 0;
    grid-column: ${({ isImageRightLayout }) =>
      isImageRightLayout ? '1 / 6' : '3 / 11'};

    /* grid-column: 1 / 6; */
    font-size: 3.6rem;
    line-height: 1.35;
  }

  @media ${DEVICE.desktop} {
    font-size: 4.8rem;
  }
`

export const BodyText = styled.div`
  font-size: 1.4rem;
  line-height: 1.9rem;
  grid-column: 2 / 10;
  color: var(--content-background-dark-blue);
  margin-top: 12px;

  @media ${DEVICE.tabletL} {
    grid-column: ${({ isImageRightLayout }) =>
      isImageRightLayout ? '1 / 6' : '3 / 11'};
    padding: 0 32px;
    font-size: 1.6rem;
    line-height: 2.2rem;
    margin-top: 19px;
  }

  @media ${DEVICE.desktop} {
    font-size: 1.8rem;
    line-height: 2.5rem;
    margin-top: 15px;
  }
`

export const NoCtaSpacer = styled.div`
  grid-column: 1 / 12;
  height: 60px;
`

export const ImageContainer = styled.div`
  grid-column: 2 / 10;
  grid-row: 2 / 5;

  @media ${DEVICE.tabletL} {
    position: relative;
    margin: 13% 0 0;
    grid-column: ${({ isImageRightLayout }) =>
      isImageRightLayout ? '6 / 10' : '2 / 6'};
    grid-row: 1;
  }
`

export const Image = styled.picture`
  border-radius: 5px;
  width: 100%;

  @media ${DEVICE.tabletL} {
    height: auto;
  }
`

export const CircleAccent = styled.div`
  width: 54px;
  height: 54px;
  grid-column: 1 / 3;
  grid-row: 1 / 3;

  @media ${DEVICE.tabletL} {
    width: 100%;
    grid-column: ${({ isImageRightLayout }) =>
      isImageRightLayout ? '9 / 11' : '1 / 3'};
  }
`
